import React from "react";

const AboutSection = () => {
  return (
    <section
      id="AboutSection"
      className="mx-auto flex flex-col items-center justify-between space-y-6 px-4 pt-10 pb-10 lg:max-w-[1146px] lg:flex-row lg:space-y-0"
    >
      <div className="flex w-11/12 flex-col items-center justify-center space-x-2 lg:w-2/3">
        <div className="w-full space-y-12 text-left">
          <div className="flex w-11/12 flex-row items-start pb-6 lg:w-2/3">
            <h1 className="text-4xl font-light leading-tight">
              How was my 6 years or more in the tech industry?
            </h1>
          </div>
          <div className="flex w-full flex-row items-center justify-between space-x-0 px-1">
            <div className="flex flex-row items-center justify-center">
              <div className="hidden w-[180px] rotate-90 border-t-[3px] border-dashed border-[#000] lg:flex"></div>
            </div>
            <div className="flex flex-col items-start justify-between space-y-3">
              <p className="text-sm font-normal leading-loose opacity-90">
                Fast-forward to today, I’ve had the privilege of working at a
                development agency, a start-up, a global corporate and a
                multiple large open source projects. My main focus these days is
                building accessible, inclusive, web or mobile products & digital
                experiences with a team of experts for a variety of worldwide
                clients.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="w-11/12 lg:w-1/3">
        <img
          src="/images/9.svg"
          alt="banner"
          className="order-1 ml-auto hidden max-w-[90%] md:max-w-[360px] lg:order-2 lg:flex"
        />
      </div>
    </section>
  );
};

export default AboutSection;
